export const PAGINATION_LIMIT = 10;
// export const PAGINATION_LIMIT = 1;

export const DATE_FORMAT = 'YYYY-M-D-ddd'; // 프론트에서 사용할 데이터 포맷
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'; // 서버에 전송할 때 사용할 데이터 포맷
export const MM_DD = 'MM.DD';
